import { create, tsx } from '@dojo/framework/core/vdom';
import { Summary } from '../../widgets/Summary';
import LinkButton from '../../widgets/LinkButton';

import * as css from './OpenSource.m.css';
import OpenSourcePage from './OpenSourcePage';
import Head from '../../widgets/Head';

const dojoLogo = require('../../assets/images/logo/medium/dojo.svg');
const internLogo = require('../../assets/images/logo/medium/intern.svg');
const dgridLogo = require('../../assets/images/logo/medium/dgrid.svg');
const dojoToolkitLogo = require('../../assets/images/logo/medium/dojo-toolkit.svg');
const tsLogo = require('../../assets/images/logo/medium/typescript.svg');

const factory = create();

export const OpenSource = factory(function OpenSource() {
	return (
		<OpenSourcePage
			background="level2BluePurple"
			heroAlign="center"
			ossLinks={false}
			pageSize="smaller"
		>
			{{
				head: (
					<Head
						title="Open Source Solutions Using TypeScript and JavaScript | SitePen"
						description="As lifelong advocates of open source software, we have harnessed their benefits since the early days of JavaScript. Learn more about our open source projects."
					/>
				),
				hero: {
					title: 'Commitment | Collaboration | Community',
					xlTitle: 'Open Source'
				},
				page: (
					<virtual>
						<div classes={css.summaryContainer}>
							<Summary>
								{{
									title: <div classes={[css.title]}>Dojo Framework</div>,
									blurb: (
										<div classes={[css.blurb]}>
											<p>
												A modern, reactive TypeScript framework for building
												robust, enterprise-grade web applications.
											</p>
											<LinkButton
												to="opensourceDojo"
												title="Learn more about our work with Dojo"
											>
												learn more
											</LinkButton>
										</div>
									),
									image: (
										<img
											loading="lazy"
											classes={[css.icon]}
											src={dojoLogo}
											alt="Dojo"
										/>
									)
								}}
							</Summary>
						</div>
						<div classes={css.summaryContainer}>
							<Summary reverse>
								{{
									title: <div classes={[css.title]}>Intern</div>,
									blurb: (
										<div classes={[css.blurb]}>
											<p>
												An all-in-one solution for full-lifecycle testing of
												JavaScript and TypeScript applications in Node and
												modern browsers.
											</p>
											<LinkButton
												to="opensourceIntern"
												title="Learn more about our work with Intern"
											>
												learn more
											</LinkButton>
										</div>
									),
									image: (
										<img
											loading="lazy"
											classes={[css.icon]}
											src={internLogo}
											alt="Intern"
										/>
									)
								}}
							</Summary>
						</div>
						<div classes={css.summaryContainer}>
							<Summary>
								{{
									title: <div classes={[css.title]}>dgrid</div>,
									blurb: (
										<div classes={[css.blurb]}>
											<p>
												A comprehensive, responsive, and modular data grid.
												Performant, scalable and embeddable within any
												application or framework including React and
												Angular.
											</p>
											<LinkButton
												to="opensourceDgrid"
												title="Learn more about our work with dgrid"
											>
												learn more
											</LinkButton>
										</div>
									),
									image: (
										<img
											loading="lazy"
											classes={[css.icon]}
											src={dgridLogo}
											alt="dgrid"
										/>
									)
								}}
							</Summary>
						</div>
						<div classes={css.summaryContainer}>
							<Summary reverse>
								{{
									title: <div classes={[css.title]}>Dojo Toolkit</div>,
									blurb: (
										<div classes={[css.blurb]}>
											<p>
												A full-featured JavaScript toolkit focused on the
												enterprise, supporting modern and legacy browsers
												and applications since 2004.
											</p>
											<LinkButton
												to="opensourceDojoToolkit"
												title="Learn more about our work with Dojo Toolkit"
											>
												learn more
											</LinkButton>
										</div>
									),
									image: (
										<img
											loading="lazy"
											classes={[css.icon]}
											src={dojoToolkitLogo}
											alt="Dojo Toolkit"
										/>
									)
								}}
							</Summary>
						</div>
						<div classes={css.summaryContainer}>
							<Summary>
								{{
									title: <div classes={[css.title]}>TypeScript</div>,
									blurb: (
										<div classes={[css.blurb]}>
											<p>
												A typed superset of JavaScript that compiles to
												plain JavaScript. Works with any browser, any host,
												any OS, and is fully open source.
											</p>
											<LinkButton
												to="opensourceTypescript"
												title="Learn more about our work with Typescript"
											>
												learn more
											</LinkButton>
										</div>
									),
									image: (
										<img
											loading="lazy"
											classes={[css.icon]}
											src={tsLogo}
											alt="TypeScript"
										/>
									)
								}}
							</Summary>
						</div>
					</virtual>
				)
			}}
		</OpenSourcePage>
	);
});

export default OpenSource;
